/** Tenant ID that has access to the SMITH assistant feature. */
export const SMITH_TENANT_ID = '0000000001';
